import { useQuery } from 'react-query'

import { request } from '../api/apiCore'

const fetchCredentialById = credentialId => request({ url: `/admin/entity_users/${credentialId}.json`, method: 'GET' })
export const useCredentialData = id => useQuery('credential', () => fetchCredentialById(id))
